<script>
export default {
  props: {
    info: Object,
    alternateImage: String,
  },
  computed: {
    imageUrl() {
      return this.info.banner_url || this.alternateImage;
    },
    backgroundColor() {
      return this.info.banner_url ? this.info.banner_bg_color : null;
    },
  },
};
</script>

<template lang='pug'>
div
  .w-full.relative.overflow-hidden(v-if='imageUrl', :style='{ backgroundColor }')
    img.opacity-100.mx-auto(v-lazy='imageUrl', alt='Collection Banner')
  .py-2.bg-brand-secondary-50
    .container.mx-auto.px-1
      .text-3xl.font-bold {{info.name}}
      .mt-1.text-brand-secondary-850.leading-tight.collection__description(v-html='info.description')
</template>

<style>
@import '~import/index';

</style>